//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import gmapsInit from "../utilities/gmaps";
import loader from "../components/loader";
import $setCookie from "../../../../js/utils/_setCookie";
import $getCookie from "../../../../js/utils/_getCookie";
import $getPrefferedLocation from "../../../../js/utils/_getPreferredLocation";
import {mapActions, mapGetters} from "vuex";

export default {
  data: () => ({
    searchText: "",
        searchBtn: "Find A Dealer",
       resetBtn: "Reset",
    placeHolder: "",
        errorAlert: false,
        resetSearch: false,
    errorMessage: "",
    distanceOption:'100',
    activeSearch: false,
    scrollLock: false,
    geocoder: null,
    active_location: null,
    infowindow: null,
    map: null,
    map_options: {},
    dealer_marker: null,
    address_components: [],
    markers: [],
    selectedMarker: null,
    bounds: null,
    loading: false,
    position: null,
    drivingError: null,
    prefLocation:null
  }),
  components: {
    loader
  },
  computed: {
    ...mapGetters(["apiKey", "locations", "icons", "options", "config", "drivingErrorMessage", "distanceOptions", "locationPlaceholder"]),
  },
  watch: {
    loading(newval, oldval) {
      if(newval === false){
        this.getCookie();
      }
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions(["loadLocations"]),
    formatPhone(el) {
      el = `${[el.slice(0, 3), el.slice(3)].join('')}`;
      return el.replaceAll('-', '.');
    },
    changeSelectDistance(event){
      this.distanceOption = event.target.value;
    },
    getLocation() {
        if (navigator.geolocation) {
             navigator.geolocation.getCurrentPosition(position =>{
              this.position = position.coords;
          this.showCurrentPosition(position)
        }, error => {this.showPositionError(error.code);
        })
        } 
      else { 
        }
    },
    getDirections(el) {
      return `https://www.google.com/maps/dir/?api=1&destination=${el.latitude},${el.longitude}`;
    },
    showPositionError(error) {
      switch(error.code) {
        case error.PERMISSION_DENIED:
          this.placeHolder = 'Enter Location Here'
          document.querySelector('.dealer__search__input').setAttribute('placeholder', this.placeHolder);
          document.querySelector('.dealer__search__input').focus();
          break;
        case error.POSITION_UNAVAILABLE:
          this.errorMessage = "Location information is unavailable."
          break;
        case error.TIMEOUT:
          this.errorMessage = "The request to get user location timed out."
          break;
        case error.UNKNOWN_ERROR:
          this.errorMessage = "An unknown error occurred."
          break;
      }
    },
    showCurrentPosition(position) {
      let latlng = {
          lat: parseFloat(position.coords.latitude),
          lng: parseFloat(position.coords.longitude),
        };
        this.geocoder.geocode({ location: latlng })
        .then((response) => {
          let zipCodTxt = '';
          if (response.results[0]) {
            for(let i=0;i<response.results.length;i++){
              let zipCode = response.results[i].address_components
              for (let j = 0; j < zipCode.length; j++) {
                if (zipCode[j].types[0] === 'postal_code') {
                  zipCodTxt = zipCode[j].short_name;
                }
              }
            }
            if(zipCodTxt != ''){
              this.searchText = zipCodTxt;
              this.handleInput();
            }
          } else {
            window.alert("No results found");
          }
        })
          .catch((e) => window.alert("Geocoder failed due to: " + e));
    },
    async readParams() {
      const params = new URLSearchParams(window.location.search);
      const exist = !params.keys().next().done;
      if (exist) {
        [...params].some(([key, value]) => {
          if (key === 'search') {
            this.searchText = decodeURIComponent(value);
            this.searchLocations();
            return true;
          }
          return false;
        })
      }
      else{
      }
    },
    setParams() {
      const url_path = window.location.pathname;
        const search_params = new URLSearchParams(window.location.search);
            search_params.set('search', this.searchText);
            history.replaceState({}, '', decodeURIComponent(`${url_path}?${search_params}`));
    },
    handleInput () {
      if (this.searchText === '') {
        this.errorAlert = true;
        return;
      }
      this.setParams();
      this.searchLocations();
      },
    resetInput () {
            this.searchText = '';
            this.distanceOption = '100';
            const url_path = window.location.pathname;
            const search_params = new URLSearchParams(window.location.search);
           
       
            search_params.delete('search');
            history.replaceState({}, '', decodeURIComponent(`${url_path}`));
           
            this.resetSearch = true;
            this.errorAlert = false;
            this.errorMessage = '';
            
            this.searchLocations();
            return;
    },
    async searchLocations() {
      this.loading = true;
      this.scrollLock = false;
      this.selectedMarker = null;
      this.active_location = null;
      this.bounds = null;
      this.address_components = [];
      this.markers.forEach(function(marker) {
        marker.setMap(null);
      });
      if (this.dealer_marker) {
        this.dealer_marker.setMap(null);
      }
      this.markers = [];
        const searched_component = await this.create_address_component({ address: this.searchText });
 
        if (!searched_component && !this.resetSearch) {
        this.loading = false
        this.errorAlert = true;
        this.errorMessage = `Search error. Please refine your search and try again. Enter a valid City and State or Zip code.`;

      } else {


            const search_component_lat = (this.resetSearch) ? this.map_options.center.lat() : searched_component.geometry['location'].lat();
            const search_component_long = (this.resetSearch) ? this.map_options.center.lng() : searched_component.geometry['location'].lng();


            let searchAddress = searched_component.formatted_address;
            
            const distance = (this.distanceOption == '') ? 100 : this.distanceOption
            const locationRequest = (this.resetSearch) ? `${this.$root.all}` : `${this.$root.api}lat=${search_component_lat}&lon=${search_component_long}&range=${distance}&rangeUnit=Miles&type=`;

            await this.loadLocations(locationRequest);

        if (this.locations.length > 0) {
          this.errorMessage = "";
          await this.drop_pins();
          setTimeout(() => {
            this.beginObserver();
          }, 500);
            if (this.resetSearch) {
                this.bounds = new google.maps.LatLngBounds();
             
            } else {
                this.map.fitBounds(this.bounds); //auto-zoom
            }
            this.activeSearch = true;
            this.resetSearch = false;

        } else {
          await this.loadLocations(`${this.$root.all}`);
          this.errorAlert = true;            
            this.errorMessage = `Found 0 locations within ${distance} mile(s) of ${searchAddress}`;
          this.bounds = new google.maps.LatLngBounds();
          await this.drop_pins();

        }
        this.loading = false
      }
    },
    async drop_pins() {
      this.bounds = new google.maps.LatLngBounds();
      this.locations.reduce(
        async (accu, location, i) => {
          if(location !== null && location !== "undefined"){
            var svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.35 24"><defs><style>.cls-1{fill:${getComputedStyle(document.body).getPropertyValue('--secondary')};}.cls-2{fill:${getComputedStyle(document.body).getPropertyValue('--primaryDark')};}</style></defs><g><path class="cls-1" d="M9.18,24c.41,0,.8-.18,1.07-.49,.83-.92,8.1-9.66,8.1-14.33C18.35,4.11,14.24,0,9.18,0S0,4.11,0,9.18c0,4.67,7.27,13.36,8.1,14.33,.27,.31,.66,.49,1.07,.49Z" /><circle class="cls-2" cx="9.18" cy="9.18" r="2.82" /></g></svg>`;
            var iconUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
            await new Promise((resolve) => {
              const marker = this.createMarker(location, i, iconUrl, false)
              this.bounds.extend(marker.getPosition());
              this.markers.push(marker);
              this.infowindow = new google.maps.InfoWindow();
              marker.addListener("click", () => {
                this.infowindow.close();
                if (this.selectedMarker) {
                  this.selectedMarker.setIcon({
                    url: iconUrl,
                    scaledSize: new google.maps.Size(this.icons.size.default, this.icons.size.default * 1.5),
                  });
                }
               const contentString =
                '<div class="infoWindow">' +
                  `<h6 class="infoWindow__heading">${location.name}</h6>` +
                  '<div class="infoWindow__content">' +
                    `<p>${location.address1}</p>` +
                    `<p>${location.address2}</p>` +
                    `<p>${location.city}, ${location.state} ${location.zip}</p>` +
                    `<a class="infoWindow__directions" href="${this.getDirections(location)}" target="_blank" rel="noopener">Get Directions</a>` +
                    `<a href="${location.url}">Full Location Details</a>` +
                  "</div>" +
                "</div>";
                 this.infowindow = new google.maps.InfoWindow({
                  content: contentString,
                });
                this.infowindow.open({
                    anchor: marker,
                    shouldFocus: false,
                });
                marker.setIcon({
                  url: iconUrl,
                  scaledSize: new google.maps.Size(this.icons.size.selected, this.icons.size.selected * 1.5),
                });
                this.selectedMarker = marker;
              });

              resolve(marker);
            });
          this.map.fitBounds(this.bounds); //auto-zoom
          }
          
        },
        Promise.resolve([])
      );

    },
    createMarker(el, index, icon, useGeocode) {
      return new this.google.maps.Marker({
        map: this.map,
        id: useGeocode ? el.place_id : index,
        icon: {
          url: icon,
          scaledSize: new google.maps.Size(this.icons.size.default, this.icons.size.default * 1.5),
        },
        position: {
          lat: useGeocode ? el.geometry.location.lat() : parseFloat(el.latitude),
          lng: useGeocode ? el.geometry.location.lng() : parseFloat(el.longitude),
        },
        __meta: {
          id: useGeocode ? el.place_id : index,
          ...el,
        }
      });
    },
    create_address_component(location) {
      return new Promise((resolve) => {
        this.geocoder.geocode(
          { address: location.address },
          (result, status) => {
            if (status !== "OK" || !result[0]) {
              resolve(false);
            }
            else{
              resolve(result[0]);
            }
          }
        );
      });
    },
    reorderLocations(elId) {
      return new Promise(async resolve => {
        let j = elId;
        let jObjIndex = this.locations.findIndex(i => i.id=== j);
        let jObj = this.locations.splice(jObjIndex,1);
        this.locations.splice(0, 0, jObj[0]);
        resolve();
      })
    },
    async beginObserver() {
      const items = document.querySelectorAll(".info__dealer");
      const options = {
        threshold: [0, 1.0]
      };
      const callback = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio === 1.0) {
            document.querySelectorAll(".info__dealer").forEach((element) => {
              element.classList.remove("active");
            });
            entry.target.classList.add('active');
            let id = entry.target.getAttribute('id').split('_')[1];
            if (!this.scrollLock) {
              google.maps.event.trigger(this.markers[id], 'click');
            }
          }
        });
      };

      const observer = new IntersectionObserver(callback, options);
      items.forEach((i) => observer.observe(i));

      setTimeout(() => {
        let firstdealer = document.querySelectorAll(".info__dealer")[0];
        firstdealer.classList.add("active");
        let id = firstdealer.getAttribute('id').split('_')[1];
        google.maps.event.trigger(this.markers[id], 'click');
      }, 250);
    },
    init() {
      return new Promise(async resolve => {
        this.google = await gmapsInit(this.apiKey);
        this.geocoder = new this.google.maps.Geocoder();
        this.drivingError = this.drivingErrorMessage;
        this.bounds = new google.maps.LatLngBounds();
        this.map_options = {
          mapTypeId: this.google.maps.MapTypeId.TERRAIN,
          clickableIcons: false,
          gestureHandling: "cooperative",
          mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
          zoom: this.options.initialZoom,
          center: new this.google.maps.LatLng(
            this.options.center.lat,
            this.options.center.lng
          ),
        };
        this.getCookie();
        this.map = new this.google.maps.Map(
          this.$el.querySelector(".maps__google"),
          this.map_options
        );
        await this.readParams();
        resolve();
      })
    },
    searchHere() {
      this.geocoder.geocode({'latLng': this.map.getCenter()}, (results, status) => {
        if (status === this.google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            for (let j = 0; j < results[0].address_components.length; j++) {
              if (results[0].address_components[j].types[0] === 'postal_code') {
                this.searchText = results[0].address_components[j].short_name;
                this.handleInput();
              }
            }
          }
        }
      });
    },
    async getCookie(){
      if ($getCookie('prefLocation') != undefined) {
        let cookieId = $getCookie('prefLocation');
        await this.reorderLocations(cookieId);
        if(document.getElementById(cookieId)!== null){
          document.getElementById(cookieId).querySelector('.icon-list__preferred-location').classList.toggle('is-active');
        }
      } 
    },
    setCookie(cookieName, cookieVal){
      $setCookie(cookieName, cookieVal, 365)
    },
    async setPreferredLocation(event){
      const eventEl = event.currentTarget;
      const prefLocations = [...document.querySelectorAll('.icon-list__preferred-location')];
      let eventElId = eventEl.parentElement.parentElement.id;
      let activeClass = eventEl.classList.contains('is-active');
      prefLocations.forEach(element => {
        element.classList.remove('is-active');
      });
      if(!activeClass){
        await this.reorderLocations(eventElId);
        this.setCookie("prefLocation", eventElId);
        $getPrefferedLocation($getCookie('prefLocation'));
        document.getElementById(eventElId).querySelector('.icon-list__preferred-location').classList.add('is-active');
      }
      else{
        this.setCookie("prefLocation", "");
        $getPrefferedLocation($getCookie('prefLocation'));
        document.getElementById(eventElId).querySelector('.icon-list__preferred-location').classList.remove('is-active');
      }
      
    }
  },
  async created() {
    await this.loadLocations(`${this.$root.all}`);
    await this.init();
    await this.drop_pins();
  },
};
